export const RequestContext = {
  BARCODE_SCANNER: 0,
  CHECK_IN_CODE: 1,
  SDK: 2,
  SEARCH_CUSTOMERS: 3,
};

export const ENROLL_CUSTOMER = 'ENROLL_CUSTOMER';
export const ENROLL_CUSTOMER_FULFILLED = 'ENROLL_CUSTOMER_FULFILLED';
export const ENROLL_CUSTOMER_REJECTED = 'ENROLL_CUSTOMER_REJECTED';
export const ENROLL_CUSTOMER_STATE_RESET = 'ENROLL_CUSTOMER_STATE_RESET';

export const ADD_CUSTOMER = 'ADD_CUSTOMER';
export const ADD_CUSTOMER_TO_SALE = 'ADD_CUSTOMER_TO_SALE';
export const ADD_CUSTOMER_TO_SALE_FULFILLED = 'ADD_CUSTOMER_TO_SALE_FULFILLED';
export const ADD_CUSTOMER_TO_SALE_REJECTED = 'ADD_CUSTOMER_TO_SALE_REJECTED';

export const GET_CUSTOMER = 'GET_CUSTOMER';
export const GET_CUSTOMER_FULFILLED = 'GET_CUSTOMER_FULFILLED';
export const GET_CUSTOMER_REJECTED = 'GET_CUSTOMER_REJECTED';
export const GET_CUSTOMER_STATE_RESET = 'GET_CUSTOMER_STATE_RESET';

export const RESET_CUSTOMER = 'RESET_CUSTOMER';
export const REMOVE_CUSTOMER_FROM_SALE = 'REMOVE_CUSTOMER_FROM_SALE';
export const REMOVE_CUSTOMER_FROM_SALE_FULFILLED =
  'REMOVE_CUSTOMER_FROM_SALE_FULFILLED';
export const REMOVE_CUSTOMER_FROM_SALE_REJECTED =
  'REMOVE_CUSTOMER_FROM_SALE_REJECTED';

export const SET_POINT_BALANCE = 'SET_POINT_BALANCE';
